
import CardLayout from "../Layout/CardLayout";
import React from "react";
import InversionTable from "./InversionTable";

const InversionVehiculos = (ciemId) => {

    const contributionForm =
        <InversionTable optionName={"inversionVehiculosTable"}
                  ciemId={ciemId}
        />
    ;

    return (
        <div className="container-fluid">
            <CardLayout value={"inversionVehiculosTitulo"} tablaComponent={contributionForm} />
        </div>
    );
};
export default InversionVehiculos;